import { compact } from 'lodash';
import type { BunkerGradeOverride, CurrentUserQuery } from '../graphql';

type Organization = NonNullable<
  CurrentUserQuery['currentUser']
>['organization'];
export type BunkerGradeCalculationMapping = Pick<
  BunkerGradeOverride,
  'id' | 'gradeName' | 'price' | 'carbonFactor'
>;

export type BunkerGradeCalculationMaps = {
  map: Map<number, BunkerGradeCalculationMapping>;
  reverseMap: Map<number, BunkerGradeCalculationMapping>;
};

/**
 * Parse bunker grade calculations from the organization data
 * Maps source bunker grade id to target bunker grade
 */
export function parseBunkerGradeCalculations(
  organization?: Organization | null,
): BunkerGradeCalculationMaps {
  const map = new Map<number, BunkerGradeCalculationMapping>();
  const reverseMap = new Map<number, BunkerGradeCalculationMapping>();

  const bunkerGradeCalculations = compact(
    organization?.bunkerGradeCalculationsByOrganizationId?.nodes ?? [],
  );

  if (!bunkerGradeCalculations.length) {
    return { map, reverseMap };
  }

  bunkerGradeCalculations.forEach((mapping) => {
    if (
      mapping.bunkerGradeOverrideByToGradeId &&
      mapping.bunkerGradeOverrideByFromGradeId
    ) {
      map.set(mapping.fromGradeId, mapping.bunkerGradeOverrideByToGradeId);
      reverseMap.set(
        mapping.toGradeId,
        mapping.bunkerGradeOverrideByFromGradeId,
      );
    }
  });

  return { map, reverseMap };
}
